import {createFileRoute} from "@tanstack/react-router"
import {Opportunities} from "@/components/opportunities/Opportunities"
import {useClaimGetQuery} from "@/api/endpoints/claim"
import {useTranslation} from "react-i18next"
import {clsx} from "@/utils/clsx"
import {Title} from "@/components/ui/Title/Title"
import styles from "./index.module.scss"
import stylesCommon from '@/common/commonStyles.module.scss'
import {Button} from "@/components/ui/Button/Button"
import {formatRemaining} from "@/utils/formatRemaining"
import {Card} from "@/components/card/Card"
import {InvestHome} from "@/components/investHome/InvestHome.tsx"
import {useGetCurrentMonthQuery} from "@/api/endpoints/other.ts"
import {useAppKitAccount} from "@reown/appkit/react"
import {useUserPools} from "@/context/UserPoolsContext.tsx"
import {useEffect} from "react"
import {loadAllData} from "@/redux/poolThunks.ts"
import {useAppDispatch} from "@/common/hooks.ts"
import {MyActiveProducts} from "@/components/home/MyActiveProducts/MyActiveProducts.tsx"
import {useSelector} from "react-redux"
import {userIsInGrowPool, userIsInSafePool} from "@/redux/selectors.ts"

export const Route = createFileRoute("/_mainLayout/")({
  component: RouteComponent,
})

function RouteComponent() {
  const {t} = useTranslation("claim")
  const jwt = localStorage.getItem("joinToken")
  const {data: claim} = useClaimGetQuery(jwt ? {join: jwt} : undefined)

  const {data: currentMonthUtc} = useGetCurrentMonthQuery()
  const {address} = useAppKitAccount()
  const {getAllPoolsState, getAllUserPools} = useUserPools()

  const dispatch = useAppDispatch()

  const isUserInSafePool = useSelector(userIsInSafePool)
  const isUserInGrowPool = useSelector(userIsInGrowPool)

  useEffect(() => {
    if (!currentMonthUtc && !address) {
      return
    }
    dispatch(loadAllData({
      currentMonthUtc,
      address,
      getAllUserPools,
      getAllPoolsState
    }))
  }, [currentMonthUtc, address, getAllUserPools])

  return (
    <div className={stylesCommon.centerContainer}>
      <div className={stylesCommon.innerStartContainer}>
        <div className={clsx(styles.row)}>
          {!!claim?.znx_amount && (
            <div className={clsx(styles.claim)}>
              <div className={clsx(styles.text)}>{t("have")}</div>
              <Title variant="green" className={clsx(styles.title)}>
                {claim?.znx_amount} {t("ZNX")}
              </Title>
              <div className={clsx(styles.text)}>{t("available")}</div>

              <div className={clsx(styles.description)}>{t("description")}</div>
              <Button
                href="/claim"
                variant="primary"
                className={clsx(styles.button)}
              >
                {t("button")}
              </Button>
              {claim?.expire_at && (
                <div className={clsx(styles.expired)}>
                  {formatRemaining(
                    claim?.expire_at || new Date().toLocaleDateString(),
                  )}
                </div>
              )}
            </div>
          )}
          <InvestHome/>
          {(isUserInSafePool || isUserInGrowPool) && <MyActiveProducts/>}
        </div>
        <Opportunities/>
        <Card/>
      </div>
    </div>
  )
}
